import DeliveryTruckIcon from "@redotech/redo-web/icon/delivery-truck.svg";
import { getStateCode } from "@redotech/redo-web/state-code";
import * as estimate from "./delivery-estimate.module.css";

const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const RedoEstimate = ({
  color,
  html,
  customCss,
  zipCode,
  country,
  city,
  region,
  estimateDate,
}: {
  color: string;
  html?: string | null;
  customCss?: string;
  zipCode: string;
  country?: string;
  city?: string;
  region?: string;
  estimateDate: string;
}) => {
  function roundEstimationDate(date: string): string {
    const dateTemp = Temporal.PlainDateTime.from(date).round("day");
    return `${month[dateTemp.month - 1]} ${dateTemp.day}`;
  }

  function getLocationDescription(): string {
    if (region && city && country === "US") {
      return `${city}, ${getStateCode(region)}`;
    } else if (region && city) {
      return `${city}, ${region}`;
    } else if (zipCode) {
      return zipCode;
    } else {
      return "your area";
    }
  }

  return (
    <>
      <div className={estimate.container} style={{ color }}>
        <style>{customCss}</style>
        <div className={estimate.deliveryIcon}>
          <DeliveryTruckIcon />
        </div>
        <span className={estimate.medSmText}>
          Ships to{" "}
          <strong>
            <u>{getLocationDescription()}</u>
          </strong>{" "}
          as early as{" "}
          <strong>
            <u>{roundEstimationDate(estimateDate)}</u>
          </strong>
        </span>
      </div>
    </>
  );
};
